import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faShieldHalved, 
  faEnvelope, 
  faKey, 
  faExclamationTriangle, 
  faRightToBracket
} from '@fortawesome/free-solid-svg-icons';
import './AdminLogin.css';

const AdminLogin = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  
  const { login, isAuthenticated } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (isAuthenticated) {
      navigate('/admin_v3jq5z/dashboard');
    }
  }, [isAuthenticated, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const result = await login(email, password);
    
    if (result.success) {
      navigate('/admin_v3jq5z/dashboard');
    } else {
      setError(result.error || 'Invalid email or password');
    }
    
    setLoading(false);
  };

  return (
    <div className="admin-login-container">
      <div className="admin-login-box">
        <div className="admin-login-header">
          <div style={{ 
            fontSize: '56px', 
            marginBottom: '20px',
            filter: 'drop-shadow(0 4px 16px rgba(99, 102, 241, 0.5))'
          }}>
            <FontAwesomeIcon 
              icon={faShieldHalved} 
              style={{
                background: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text',
                color: '#6366f1'
              }}
            />
          </div>
          <h1>Admin Panel</h1>
          <p>Blog Management System</p>
        </div>

        {error && (
          <div className="admin-alert admin-alert-error">
            <FontAwesomeIcon icon={faExclamationTriangle} style={{ marginRight: '8px', color: '#dc2626' }} />
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} className="admin-login-form">
          <div className="admin-form-group">
            <label htmlFor="email">
              <FontAwesomeIcon icon={faEnvelope} style={{ marginRight: '8px', color: '#6366f1' }} />
              Email Address
            </label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="admin@blog.bonlineco.com"
              required
              disabled={loading}
              autoComplete="email"
            />
          </div>

          <div className="admin-form-group">
            <label htmlFor="password">
              <FontAwesomeIcon icon={faKey} style={{ marginRight: '8px', color: '#8b5cf6' }} />
              Password
            </label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              required
              disabled={loading}
              autoComplete="current-password"
            />
          </div>

          <button 
            type="submit" 
            className={`admin-btn admin-btn-primary ${loading ? 'admin-btn-loading' : ''}`}
            disabled={loading}
          >
            {loading ? '' : (
              <>
                <FontAwesomeIcon icon={faRightToBracket} style={{ marginRight: '8px' }} />
                Sign In
              </>
            )}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
